export const environment = {
  production: true,
  propxyUrl: 'https://api.gamifyroute.com/master/api/v1/Proxy?url=',
  apis: {
    ig_api: 'https://api.gamifyroute.com/interactive-result/api',
    ip_api: 'https://api.gamifyroute.com/informative-result/api',
    lg_api: 'https://api.gamifyroute.com/form-result/api',
  },
  seo_api: 'https://api.gamifyroute.com/gamify-campaign/api',
  preview: false,
  bucketAwsUrl: 'https://app-gamifyroute-public-asset.s3.amazonaws.com/',
  defaultImgUrl: './assets/media/inline-svg/placeholder/lazyImageLoad.png',
};
